
export const TAB_INTRO = 'intro'
export const TAB_FRONT = 'front'
export const TAB_BACK = 'back'
export const TAB_FACE = 'face'
export const TAB_PREVIEW = 'face'
export const TAB_LIVELINESS = 'liveliness'
export const TAB_SUBMIT = 'submit'
export const TAB_RESULT = 'result'
